import { doc, getDoc } from "firebase/firestore";
import { FirestoreCollections, firestore } from "../../../firebase.config";
import Failure from "../../../core/Failure";
import { IAdmin } from "@leedpulse-monorepo/interfaces";

async function getAdminById(adminId: string): Promise<IAdmin | null> {
  try {
    const db = firestore;

    const adminDocRef = await getDoc(
      doc(db, FirestoreCollections.admins, adminId)
    );

    if (!adminDocRef.exists()) {
      return null;
    }

    return { id: adminDocRef.id, ...adminDocRef.data() } as IAdmin;
  } catch (e) {
    console.log("error: ", e);
    throw new GetAdminByIdFailure();
  }
}

export class GetAdminByIdFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default getAdminById;
